export enum ExternalSourceType {
  Bolt,
  Xpm
}
